import React from 'react';
import { ReactComponent as Glitter } from 'style/_assets/icons/glitter.svg';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import NegativeMarksList from 'components/NegativeMarksList';
import { Button } from 'components/form/Button/Button';
import './CreditRepairExpertTip.scss';

const CreditRepairExpertTipView = props => {
  const { seenPixel, creditInfo, onClickCall } = props;
  return (
    <SectionContainer className="creditRepairExpertTip">
      {seenPixel}
      <Row className="margB0">
        <Label type="H4" typeHeader={'h4'} className="margB16">
          Tip
        </Label>
        <FlexContainer>
          <Glitter />
          <Label type="Subtitle-1" className="margL8 t-text-14">
            Act now. Feel the impact later.
          </Label>
        </FlexContainer>
        <FlexContainer>
          <div className="verticalDivider margL12 margR18 margT6" />
          <p className="Body-1 margB0 pad0 t-text-12 m-margr32">
            Check out the breakdown of negative marks on your profile and call
            our credit repair experts from Lexington Law for a consultation.
          </p>
        </FlexContainer>
      </Row>
      <Row className="margB0">
        <NegativeMarksList
          paymentHistory={creditInfo?.creditScoreAnalysis?.paymentHistory}
          className="padLR16 padT16"
        />
      </Row>
      <Row className="desktopOnlyHide margT32">
        <Button
          mrphType="primary"
          href="tel:844-764-1547"
          className="callButton flex-container justify-center items-align-center"
          onClick={onClickCall}
        >
          Call 844-764-1547
        </Button>
      </Row>
    </SectionContainer>
  );
};

export default CreditRepairExpertTipView;
